export enum PropertyRoomsNumberEnum {
  ANY = '0',
  VAL_1 = '1',
  VAL_2 = '2',
  VAL_3 = '3',
  VAL_4 = '4',
  VAL_5 = '5',
}
